import * as React from 'react';
import { Box, ParagraphText } from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import type {
  RootEntityCloneItem,
  Nullable,
  EntityNamesMap,
} from '@web-config-app/core';
import { EntityCloneList } from '../entity-clone-list/entity-clone-list.component';
import { FullscreenConfirmationModal } from '../fullscreen-confirmation-modal/fullscreen-confirmation-modal.component';

export interface DeepCloneModalProps {
  isOpen: boolean;
  data?: Nullable<RootEntityCloneItem | undefined>;
  isLoadingDeepCloneGetData: boolean;
  errorMessage?: Nullable<string>;
  deepCloneAction: () => void;
  onNameChange: (id: string, name: string) => void;
  onClose: () => void;
  entityNamesMap?: EntityNamesMap;
}

export const DeepCloneModal = ({
  isOpen,
  data,
  isLoadingDeepCloneGetData,
  deepCloneAction,
  onNameChange,
  errorMessage = null,
  onClose,
  entityNamesMap = {},
}: DeepCloneModalProps) => {
  const { formatMessage } = useIntl();
  const isReady = !isLoadingDeepCloneGetData && data;
  return (
    <FullscreenConfirmationModal
      isOpen={isOpen}
      onClose={onClose}
      titleId="DEEP_CLONE_MODAL_TITLE"
      descriptionId="DEEP_CLONE_MODAL_DESCRIPTION"
      isLoading={isLoadingDeepCloneGetData}
      loadingTextId="DEEP_CLONE_MODAL_FETCHING_TEXT"
      confirmLabel={formatMessage({
        id: 'DEEP_CLONE_MODAL_PROCEED_BUTTON',
      })}
      onConfirm={() => deepCloneAction()}
      isConfirmDisabled={Boolean(errorMessage)}
    >
      {isReady && !errorMessage && (
        <Box as="form" css={{ maxWidth: 800 }}>
          <EntityCloneList
            entity={data}
            onNameChange={onNameChange}
            entityNamesMap={entityNamesMap}
          />
        </Box>
      )}
      {errorMessage && (
        <ParagraphText css={{ color: '$onSurfaceTextCritical' }}>
          {errorMessage}
        </ParagraphText>
      )}
    </FullscreenConfirmationModal>
  );
};
